import toast from 'react-hot-toast';

export interface ToastOptions {
  duration?: number;
  position?: 'top-left' | 'top-center' | 'top-right' | 'bottom-left' | 'bottom-center' | 'bottom-right';
  icon?: string;
  style?: React.CSSProperties;
  className?: string;
}

export class ToastService {
  static showError(message: string, options?: ToastOptions) {
    return toast.error(message, {
      duration: 5000,
      position: 'top-right',
      style: {
        background: '#fee2e2',
        color: '#dc2626',
        border: '1px solid #fecaca',
        borderRadius: '8px',
        padding: '12px 16px',
        fontSize: '14px',
        fontWeight: '500',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      },
      ...options,
    });
  }

  static showSuccess(message: string, options?: ToastOptions) {
    return toast.success(message, {
      duration: 3000,
      position: 'top-right',
      style: {
        background: '#d1fae5',
        color: '#059669',
        border: '1px solid #a7f3d0',
        borderRadius: '8px',
        padding: '12px 16px',
        fontSize: '14px',
        fontWeight: '500',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      },
      ...options,
    });
  }

  static showWarning(message: string, options?: ToastOptions) {
    return toast(message, {
      duration: 4000,
      position: 'top-right',
      icon: '⚠️',
      style: {
        background: '#fef3c7',
        color: '#d97706',
        border: '1px solid #fde68a',
        borderRadius: '8px',
        padding: '12px 16px',
        fontSize: '14px',
        fontWeight: '500',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      },
      ...options,
    });
  }

  static showInfo(message: string, options?: ToastOptions) {
    return toast(message, {
      duration: 3000,
      position: 'top-right',
      icon: 'ℹ️',
      style: {
        background: '#dbeafe',
        color: '#2563eb',
        border: '1px solid #93c5fd',
        borderRadius: '8px',
        padding: '12px 16px',
        fontSize: '14px',
        fontWeight: '500',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      },
      ...options,
    });
  }

  static dismiss(toastId?: string) {
    if (toastId) {
      toast.dismiss(toastId);
    } else {
      toast.dismiss();
    }
  }

  static dismissAll() {
    toast.dismiss();
  }
}

// Convenience functions for common error scenarios
export const showApiError = (error: any) => {
  let message = 'An unexpected error occurred';
  
  if (error?.response?.data?.message) {
    message = error.response.data.message;
  } else if (error?.message) {
    message = error.message;
  } else if (typeof error === 'string') {
    message = error;
  }

  return ToastService.showError(message);
};

export const showNetworkError = () => {
  return ToastService.showError('Network error. Please check your connection and try again.');
};

export const showValidationError = (message: string) => {
  return ToastService.showError(`Validation error: ${message}`);
};

export const showAuthError = (message: string) => {
  return ToastService.showError(`Authentication error: ${message}`);
};

export default ToastService;
